import React, { Component } from 'react';
import TableHead from '../component/TableHead.js';
import Submit from '../component/Submit.js';
import axios from 'axios';
import {path,mail} from './routes.js';
import CreateUser from './CreateUser.js'; //each row of inputs and selects for new user information is contained in this component
import Modal from 'react-modal';
import sparkles2 from '../asset/img/sparkles2.png';
import Validation from './Validation.js'; //used for validation
import loader from '../asset/img/loader.gif';

export default class BulkUser extends Component {
	constructor(props){
		super(props);
		this.state = {newUsers:[],departments:[],userTypes:[],failedUsers:[],rows:8,submit:false,modalIsOpen:false,incomplete:false,messagePrompt:''};
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.openModal = this.openModal.bind(this);
    	this.closeModal = this.closeModal.bind(this);
		this.addRows = this.addRows.bind(this);
		this.getUserInfo = this.getUserInfo.bind(this);
		this.logsubmit = this.logsubmit.bind(this);
		this.loadingFunc = this.loadingFunc.bind(this);
	}

	loadingFunc(loading){ //method for loading gif
		if(loading){
			this.setState({loading:true},function(){
				this.openModal();
			});
		}else{
			this.setState({loading:false});
		}
	}

	getUserInfo(){ //method that retrieves all departments and user types
		axios({ //retrieve departments
			method:'post',
			url:path,headers:{'Content-Type':'application/json'},
			data:{endpoint:'info',table:'department'}
		}).then((response)=>{
			let departments = [];
			let data = response.data.data;
			data.forEach((d)=>{
				departments.push(d.department);
			});
			this.setState({departments:departments});
		});

		axios({ //retrieve user types
			method:'post',
			url:path,headers:{'Content-Type':'application/json'},
			data:{endpoint:'info',table:'user_type'}
		}).then((response)=>{
			let types = [];
			let data = response.data.data;
			data.forEach((type)=>{
				types.push(type.type);
			});
			this.setState({userTypes:types});
		});
	}

	componentDidMount(){ //when component mounts, retrieve necessary information
		this.getUserInfo();
	}

	handleChange(newUser){ //method grabs all of the new users and adds them to the state since each new user is contained in the CreateUser component
		this.setState(oldState => ({newUsers:[...oldState.newUsers,newUser]}));
	}

	handleSubmit(){ //method that sets submit to true, which sets all operations for submitting the new users into motion
		this.setState({submit:true},function(){
			this.loadingFunc(true);
		});
	}

	logsubmit(failure){ //method that keeps track of incomplete user data
		this.setState({incomplete:failure});
	}

	componentDidUpdate(prevProps,prevState){
		if((prevState.submit === true) && (prevState.newUsers !== this.state.newUsers) && (this.state.newUsers.length !== 0)){ //if all new user information has been passed up from create user components
			let newUsers = this.state.newUsers;
			let failures = [];
			let userCreate = [];
			newUsers.forEach((user)=>{ //validate each field and the either push to be sent or into failed
				if(Validation("name",user.name) && Validation("email",user.email) && Validation("pword",user.password) && user.complete){
					userCreate.push(axios({
						method:'post',
						url:path,
						headers:{'Content-Type':'application/json'},
						data:{endpoint:'create',table:'users',name:user.name,email:user.email,misc:user.password,picture:user.department,status:user.userType}
					}).catch(()=>{
						failures.push(user);
					}));
				}else{
					if(user.name.trim() === ''){
						user.name = "BLANK";
					}
					if(user.email.trim() === ''){
						user.email = "BLANK";
					}
					failures.push(user);
				}
			});
			this.setState({submit:false});
			this.setState({failedUsers:failures},function(){
				axios.all(userCreate).then(()=>{ //send all valid new users
					this.setState({newUsers:[], messagePrompt:'All users created successfully!'});
					this.props.logChange();
					this.loadingFunc(false);
					if(this.state.incomplete){
						this.closeModal();
					}
				});
			});
		}else if(prevState.submit === true && this.state.submit === true){ //if no information has been entered but submit has been clicked
			this.setState({submit:false, messagePrompt:'Please Input at least one user.'});
			this.loadingFunc(false);
			if(this.state.incomplete){
				this.closeModal();
			}
		}
	}

	openModal() { //method to open the modal
    	this.setState({modalIsOpen: true});
  }

	closeModal() { //method to close the modal
	    this.setState({modalIsOpen: false,submit:false,failedUsers:[]});
	}

	addRows(){ //method to add rows (CreateUser components)
		let oldRows = this.state.rows;
		let newRows = oldRows + 5;
		this.setState({rows:newRows});
	}

	render(){
		let content;
		const customStyles = {
		  content : {
		    top: '50%',
		    left: '50%',
		    right: 'auto',
		    bottom: 'auto',
		    width:'100%',
		    minWidth:'300px',
		    maxWidth:'600px',
		    minHeight:'200px',
		    maxHeight:'600px',
		    borderStyle:'solid',
		    borderWidth:'2px',
		    borderColor:'gray',
		    transform: 'translate(-50%, -50%)',
		    backgroundImage:'url('+sparkles2+')',
		    backgroundRepeat:'no-repeat',
		    backgroundSize: '300px 160px',
		    backgroundPosition:'right',
		    boxShadow:'0.5px 0.5px 1px 0.5px'
			},  
			overlay:{
				backgroundColor:'rgba(105,105,105,0.8)'
			}
		};
		const tableRows = [];
		for (var i = 0; i < this.state.rows; i++) { //generate rows of inputs and selects for new user information
      		tableRows.push(<CreateUser key={i} id={i} onChange={this.handleChange} submit={this.state.submit} departments={this.state.departments} userTypes={this.state.userTypes} employees={this.state.employees} failed={this.logsubmit}/>);
    }
    let modalContent;
    let failed = this.state.failedUsers;
    let incomplete;
    if(this.state.loading){ //display loader gif
    	modalContent = <div className="tc" style={{width:'150px',margin:'auto'}}><img src={loader} alt="Loading" /></div>;
    }else if(failed.length > 0){ //display all failed users to be created
    	modalContent = <div className="tc">
    										<div className="fl w-100 tr">
								        	<button className="bg-white gray b br3" onClick={this.closeModal}>X</button>
								        </div>
    										<p className="tc b f4 navy">There was a problem creating the following users: </p>
    										<div style={{overflowY:'auto'}}><UnOrderedList failed={failed}/></div>
    								</div>;
    }else{ //display message
    	modalContent = <div className="tc">
    										<div className="fl w-100 tr">
								        	<button className="bg-white gray b br3" onClick={this.closeModal}>X</button>
								        </div>
    										<p className="tc b f3 navy mt0">{this.state.messagePrompt}</p>
    								</div>;
    }
    if(this.props.active){
    	content = <div>
    							<div className="br3 pa3 ba b--light-silver" style={{boxShadow:'0px 0px 5px 5px #aaaaaa inset',overflowY:'auto',maxHeight:'475px'}}>
										<div style={{maxWidth:'100%'}}>
											<table className="fl w-100">
												<thead>
													<TableHead columns={["Name","Email","Password","Department","User Type"]}/>
												</thead>
												<tbody>
													{tableRows}
												</tbody>
											</table>
										</div>
										<div className="tr mr3">
											<a href="#" onClick={this.addRows} className="blue no-underline underline-hover">+Add Rows</a>
										</div>
									</div>
									<div className="mt4 mb2">
										{incomplete}
										<Submit name="Submit" onClick={this.handleSubmit} styles="br3 white b w-20-ns w-50 hh3 bg-navy shadow-3"/>
									</div>
									<div>
										<Modal
							          isOpen={this.state.modalIsOpen}
							          style={customStyles}
							          contentLabel="Account Creation Modal"
							          shouldCloseOnOverlayClick={false}
							          shouldCloseOnEsc={false}
							        >
							        {modalContent}
							        </Modal>
									</div>
								</div>;
    }
		return(
			<div>
				{content}
			</div>
		);
	}
}

const UnOrderedList = props =>{ //unordered list functional component to display failed new users
		let li = props.failed.map((failed,i)=>{
			return <li key={i} className="fl w-100"><p className="fl w-50 b f5 navy tl pa0 bb b--light-silver mt0">{failed.name}</p><p className="fl w-50 b f5 tl navy pa0 mt0 bb b--light-silver">{failed.email}</p></li>;
		});
		return <ul className="fl w-100">{li}</ul>;
}


// WEBPACK FOOTER //
// ./src/container/BulkUser.js